/**
 * Banner
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {BannerCollection} from '@/model/collection/BannerCollection'

/* TODO: review generated class */
export class Banner extends Resource {
  idBannerPk: number = 0

  nome: string | null = null
  urlImagem: string | null = null
  urlRedirect: string | null = null
  dataInicio: string | null = null
  dataFim: string | null = null
  dataCriacao: string | null = null
  ativo: boolean | null = null

  get $id() {
    return this.idBannerPk
  }
  set $id(val) {
    this.idBannerPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  /**
   * Gets a instance of a given ID of Banner
   */
  async getBanner(id: number) {
    return await Request.get(`/admin/banner/${id}`)
      .name('getBanner')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of Banner
   */
  async removeBanner() {
    return await Request.delete(`/admin/banner/${this.$id}`)
      .name('removeBanner')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Banner
   */
  static async listBanner(params: any) {
    return await Request.get(`/admin/banner`, {params})
      .name('listBanner')
      .as(BannerCollection)
      .getData()
  }

  /**
   * Persists a new instance of Banner. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistBanner() {
    return await Request.post(`/admin/banner`, this)
      .name('persistBanner')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Banner to use it in a CSV file
   */
  static async listCsvBanner(params: any) {
    return await Request.get(`/admin/banner/csv`, {params})
      .name('listCsvBanner')
      .as(BannerCollection)
      .getData()
  }
}
